import { AdminRole } from "@repo/api-dtos"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import * as React from "react"
import { useAdminRolesContext } from "@/contexts/admin-roles-context"
import { InternalPassesEditor } from "@/features/internal-passes/InternalPassesEditor"

export const Route = createFileRoute("/configuration/internal-passes")({
	component: InternalPassesPage,
})

function InternalPassesPage() {
	const navigate = useNavigate()
	const { hasRole } = useAdminRolesContext()
	const canRead = hasRole(AdminRole.Superadmin)

	React.useEffect(() => {
		if (!canRead) navigate({ to: "/unauthorized" })
	}, [canRead, navigate])
	if (!canRead) return null

	return <InternalPassesEditor />
}
